// extracted by mini-css-extract-plugin
export var alert = "Alert-module--alert--de6b6";
export var alertBannerWrapper = "Alert-module--alertBannerWrapper--bf6c0";
export var alertBody = "Alert-module--alertBody--d66a2";
export var alertClose = "Alert-module--alertClose--d6f96";
export var alertFlexWrapper = "Alert-module--alertFlexWrapper--a5fe6";
export var alertFlexWrapperInner = "Alert-module--alertFlexWrapperInner--bb810";
export var alertHeading = "Alert-module--alertHeading--60924";
export var alertIsDismissible = "Alert-module--alertIsDismissible--e259d";
export var noChildren = "Alert-module--noChildren--754a7";
export var srOnly = "Alert-module--srOnly--31b72";